// src/api/authApi.js
import { api } from "./client";

export const authApi = {
  // The caller's own profile (id/username/email/org_id/is_active) plus
  // their full nested permissions map — {global_permissions, accounts,
  // projects} — every account/project they hold any role on. Fetched once
  // (login/page-load) and again on every protected-route navigation (see
  // ProtectedOutlet.jsx, which reads is_active off this to force out a
  // deactivated user). See presentation/shared/access_provisioning/
  // auth_controller.py::GET /me and effective_permissions_cache.py --
  // this merges what used to be a separate GET /users/me.
  effectivePermissions: () => api.get("/auth/me"),

  // No trailing slash — rbac_controller.py defines these as "/roles" /
  // "/permissions" literally, not "/" under the prefix. level narrows the
  // catalog server-side to one RoleLevel (e.g. "project", "account") — see
  // ListRolesQuery's own docstring on the backend. search/page/pageSize are
  // also applied server-side — response is {items, total, page, page_size,
  // total_pages}, not a bare array.
  listRoles: ({ level, search, page = 1, pageSize = 20 } = {}) => {
    const params = { page, page_size: pageSize };
    if (level) params.level = level;
    if (search) params.search = search;
    return api.get("/auth/roles", { params });
  },
  listPermissions: ({ search, page = 1, pageSize = 20 } = {}) => {
    const params = { page, page_size: pageSize };
    if (search) params.search = search;
    return api.get("/auth/permissions", { params });
  },
};
